<template>
  <div class="crunch">
    <h3>{{ data.number }}</h3>
    <div :class="['answer', {active: active}]">
      <p>{{ data.answer }}</p>
      <button type="button" @click.prevent="reveal()" v-if="!active"><sprite name="iconHelpCircled" /></button>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ContentModuleAudio',
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        active: false
      }
    },
    methods: {
      reveal () {
        this.active = true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  h3, p {
    text-align:center;
  }

  h3 {
    font-size:3rem; line-height:1; font-weight:300; margin-bottom:3rem;
  }

  .answer {
    border-radius:3px; position:relative; min-height:3em;
    p {
      opacity:0; transition:opacity .3s; margin:0;
    }
    &.active p {
      opacity:1;
    }
  }

  button {
    @include transition();
    @include button-reset;
    position:absolute; width:100%; height:100%; top:0; left:0; border:1px dashed $color-primary-darker; border-radius:4px;
    &:hover, &:focus {
      background-color:$color-white; border-color:$color-primary;
      svg {
        fill:$color-primary;
      }
    }
    svg {
      @include transition();
      @include size(4rem);
      fill:$color-primary-darker;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/number-crunch.vue